<script>
  import Button from "./Button.svelte";
  import Tooltip from "./Tooltip.svelte";

  let mouseenter = () => {};
  let mouseleave = () => {};
  let focus = () => {};
  let blur = () => {};
  let click = () => {};

  export let el;
  export let placement;

  export {
    mouseenter as onmouseenter,
    mouseleave as onmouseleave,
    focus as onfocus,
    blur as onblur,
    click as onclick,
  };

  const getEventHandlers = (tooltipHandlers) => ({
    onmouseenter: (e) => {
      tooltipHandlers.onmouseenter(e);
      mouseenter(e);
    },
    onmouseleave: (e) => {
      tooltipHandlers.onmouseleave(e);
      mouseleave(e);
    },
    onfocus: (e) => {
      tooltipHandlers.onfocus(e);
      focus(e);
    },
    onblur: (e) => {
      tooltipHandlers.onblur(e);
      blur(e);
    },
    onclick: (e) => {
      tooltipHandlers.dismiss(e);
      return click(e);
    },
  });
</script>

<Tooltip
  {placement}
  let:onmouseenter
  let:onmouseleave
  let:onblur
  let:onfocus
  let:dismiss
>
  <span slot="tooltip"><slot name="tooltip" /></span>
  <!-- If statements prevents gap being rendered when button has no text -->
  {#if $$slots.default}
    <Button
      bind:el
      {...$$restProps}
      {...getEventHandlers({
        onmouseenter,
        onmouseleave,
        onfocus,
        onblur,
        dismiss,
      })}
    >
      <slot />
    </Button>
  {:else}
    <Button
      bind:el
      {...$$restProps}
      {...getEventHandlers({
        onmouseenter,
        onmouseleave,
        onfocus,
        onblur,
        dismiss,
      })}
    />
  {/if}
</Tooltip>
